/**
 * We map both the readable key as well as the number keycode to ensure
 * compatibility with older browsers
 */
const keyboardKeyMapping = {
  TAB: ['Tab', 9],
  SPACE: ['Space', ' ', 32],
  ENTER: ['Enter', 13],
  ESC: ['Escape', 'Esc', 27],
  SHIFT: ['Shift', 16],
  CTRL: ['Ctrl', 'Control', 17],
  ARROW_UP: ['ArrowUp', 'Up', 38],
  ARROW_DOWN: ['ArrowDown', 'Down', 40],
  ARROW_LEFT: ['ArrowLeft', 'Left', 37],
  ARROW_RIGHT: ['ArrowRight', 'Right', 39],
  HOME: ['Home', 36],
  END: ['End', 35]
};
/**
 * Asserts whether a keyboard event matches a certain key
 * @param e KeyboardEvent or synthetnic React.KeyboardEvent
 * @param keyName whatever human readable key you want to detect
 * @returns {boolean}
 */
function isKey(e, keyName) {
  const key = getKeyFromKeyboardEvent(e);
  return keyboardKeyMapping[keyName].includes(key);
}
/**
 * Gets us a compatible key name / number (.keyCode is deprecated, but still in use to support IE11)
 * @param e KeyboardEvent or synthetnic React.KeyboardEvent
 */
function getKeyFromKeyboardEvent(e) {
  return e.key || e.keyCode;
}
/**
 * Return the normalized key name that corresponds to a given event key code
 * @param e KeyboardEvent or synthetnic React.KeyboardEvent
 */
const getNormalizedKeyFromKeyboardEvent = e => Object.keys(keyboardKeyMapping).find(k => isKey(e, k));

export { getKeyFromKeyboardEvent, getNormalizedKeyFromKeyboardEvent, isKey };
//# sourceMappingURL=keyboard.js.map
